import { useState } from "react";
import SplashScreen from "../components/SplashScreen/SplashScreen";
import VSApp from "./VSApp";

const DemoApp = () => {
  const [splash, setSplash] = useState(true);
  return (
    <div>
      {splash ? (
        <SplashScreen setSplash={setSplash} />
      ) : (
        <VSApp setSplash={setSplash} />
      )}
    </div>
  );
};

export default DemoApp;
